
import { MapTo } from '@adobe/aem-react-editable-components';
import MobileWalletAdModule, { MobileWalletAdModuleEditConfig } from './MobileWalletAdModule';

export default MapTo('cob-corp-acquisition/components/creditonebank/mobile-wallet-ad-module')(MobileWalletAdModule, MobileWalletAdModuleEditConfig);
        